// extracted by mini-css-extract-plugin
module.exports = {"root":"image-module--root--D1cYh","img":"image-module--img--1nSBV","photoCredit":"image-module--photoCredit--21mQK"};